export const MAIN_ROUTE = "/";
export const OLD_MAIN_ROUTE = "/cb";
export const ABOUT_ROUTE = "/about";